"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var react_device_detect_1 = require("react-device-detect");

exports.Footer = function (_a) {
  var customerServiceURL = _a.customerServiceURL,
      termsOfUseURL = _a.termsOfUseURL,
      ldeURL = _a.ldeURL,
      creditsURL = _a.creditsURL,
      isFooter = _a.isFooter,
      cookieEvent = _a.cookieEvent;
  return react_1.default.createElement("div", {
    className: "row mb-2",
    style: {
      position: "relative",
      top: "-2rem",
      padding: "2.5rem 0px",
      background: "var(--gray-0)"
    }
  }, isFooter && react_1.default.createElement(react_1.default.Fragment, null, react_device_detect_1.isMobile && react_1.default.createElement("div", {
    className: "col-lg-12 d-flex justify-content-center flex-column align-items-center"
  }, react_1.default.createElement("a", {
    href: customerServiceURL,
    target: "_blank"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "caption",
    weight: "light"
  }, "Contact")), react_1.default.createElement("a", {
    href: termsOfUseURL,
    target: "_blank"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "caption",
    weight: "light"
  }, "Mentions l\xE9gales")), react_1.default.createElement("a", {
    href: creditsURL,
    target: "_blank"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "caption",
    weight: "light"
  }, "Conditions d'utilisation")), react_1.default.createElement("a", {
    href: ldeURL,
    target: "_blank"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "caption",
    weight: "light"
  }, "Site institutionnel de SUEZ")), react_1.default.createElement("a", {
    onClick: cookieEvent,
    className: "cursor-pointer"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "caption",
    weight: "light"
  }, "G\xE9rer les cookies"))), react_device_detect_1.isBrowser && react_1.default.createElement("div", {
    className: "col-lg-12 d-flex justify-content-center"
  }, react_1.default.createElement("a", {
    href: customerServiceURL,
    target: "_blank"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "caption",
    weight: "light"
  }, "Contact | \xA0")), react_1.default.createElement("a", {
    href: termsOfUseURL,
    target: "_blank"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "caption",
    weight: "light"
  }, "Mentions l\xE9gales | \xA0")), react_1.default.createElement("a", {
    href: creditsURL,
    target: "_blank"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "caption",
    weight: "light"
  }, "Conditions d'utilisation | \xA0")), react_1.default.createElement("a", {
    href: ldeURL,
    target: "_blank"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "caption",
    weight: "light"
  }, "Site institutionnel de SUEZ | \xA0")), react_1.default.createElement("a", {
    onClick: cookieEvent,
    className: "cursor-pointer"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "caption",
    weight: "light"
  }, "G\xE9rer les cookies")))));
};

exports.default = exports.Footer;